import QUERY_KEYS from '@app/common/queryKeys';
import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

interface UseInvalidateResetQueriesProps {
  userId?: number;
}

const useInvalidateResetQueries = (props: UseInvalidateResetQueriesProps) => {
  const queryClient = useQueryClient();

  const userId = props?.userId;

  // full page notifications

  const invalidateFullNotificationPage = () => {
    queryClient.invalidateQueries({
      queryKey: [QUERY_KEYS.NOTIFICATIONS_LIST_FULL, 'infinite', userId],
    });
  };

  const resetInfiniteQueriesCacheToNotFetchAllTheOffsetPages = () => {
    queryClient.resetQueries({
      queryKey: [QUERY_KEYS.NOTIFICATIONS_LIST_FULL, 'infinite', userId],
    });
  };

  const removeFullNotificationPage = async () => {
    // await queryClient.cancelQueries({
    //   queryKey: [QUERY_KEYS.NOTIFICATIONS_LIST_FULL, 'infinite', userId],
    //   exact: false,
    // });
    queryClient.removeQueries({ queryKey: [QUERY_KEYS.NOTIFICATIONS_LIST_FULL, 'infinite', userId], exact: false });
  };

  const refetchFullNotificationPageAsync = useCallback(async () => {
    await queryClient.refetchQueries({
      queryKey: [QUERY_KEYS.NOTIFICATIONS_LIST_FULL, 'infinite', userId],
      type: 'all', // <- include inactive queries
      exact: true, // <- avoid accidentally matching similar keys
    });
  }, [queryClient, userId]);

  // widget queries

  const invalidateWidgetNotifications = useCallback(() => {
    queryClient.invalidateQueries({
      queryKey: [QUERY_KEYS.NOTIFICATIONS_WIDGET, userId],
    });
  }, [queryClient, userId]);

  const refetchWidgetNotificationsAsync = useCallback(async () => {
    await queryClient.refetchQueries({
      queryKey: [QUERY_KEYS.NOTIFICATIONS_WIDGET, userId],
    });
  }, [queryClient, userId]);

  return {
    resetInfiniteQueriesCacheToNotFetchAllTheOffsetPages,
    removeFullNotificationPage,
    invalidateFullNotificationPage,
    refetchWidgetNotificationsAsync,
    invalidateWidgetNotifications,
    refetchFullNotificationPageAsync,
  };
};

export default useInvalidateResetQueries;
